import { RichTextRendererError } from './RichTextRendererError';
export const resolveRichTextElementMetadata = (element, metadata) => {
    var _a;
    let reference = undefined;
    if ('referenceId' in element && typeof element['referenceId'] === 'string') {
        const resolved = (_a = metadata.references) === null || _a === void 0 ? void 0 : _a.get(element['referenceId']);
        if (resolved === undefined) {
            throw new RichTextRendererError(`Cannot find reference id '${element['referenceId']}'` +
                (metadata.references === undefined
                    ? ` because its containing block's lacks the '${metadata.referencesField}' field. `
                    : `.`));
        }
        reference = resolved;
    }
    let referenceRenderer = undefined;
    let referenceType = undefined;
    if (reference && metadata.referenceDiscriminationField) {
        referenceType = reference[metadata.referenceDiscriminationField];
        referenceRenderer = metadata.referenceRenderers[referenceType];
    }
    return {
        formatVersion: metadata.formatVersion,
        reference,
        referenceType,
        referenceRenderer,
    };
};
//# sourceMappingURL=resolveRichTextElementMetadata.js.map